import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import { Box, Stack, Typography } from '@mui/material';
import { CountryBadge, CurrencyInput, formatCurrencyValue } from 'framework/form';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';
import type { SalaryRange } from '../types';
import PositionProfileInformationFields from './inputs/PositionProfileInformationFields';

const currencyInputSx = {
  width: 255,
  mb: 0,
};

const countryBadgeSx = {
  '& img': {
    width: '40px',
    height: '28px',
    borderRadius: 1,
  },
};

const salaryRangeAdornment = (direction: 'up' | 'down') => {
  const DirectionIcon = direction === 'up' ? ArrowUpwardOutlinedIcon : ArrowDownwardOutlinedIcon;

  return (
    <Stack direction="row" spacing={0.25} alignItems="center">
      <AttachMoneyOutlinedIcon fontSize="small" />
      <DirectionIcon fontSize="small" />
    </Stack>
  );
};

export const getPositionProfileFormSections = (
  salaryRanges: SalaryRange[],
  isDefinitionDisabled: boolean,
): CreateEditFormSection[] => [
  {
    id: 'profile-information',
    title: 'Profile information',
    content: <PositionProfileInformationFields isDefinitionDisabled={isDefinitionDisabled} />,
  },
  {
    id: 'salary-ranges',
    title: 'Salary ranges',
    content: (
      <Stack gap={2}>
        {salaryRanges.map((range, index) => (
          <Stack key={range.officeId} direction="row" gap={2} alignItems="center" flexWrap="wrap">
            <CurrencyInput
              source={`salaryRanges.${index}.minValue`}
              label="Min value"
              allowDecimal={false}
              endAdornment={salaryRangeAdornment('down')}
              formatInitialValue={formatCurrencyValue}
              maxDecimal={0}
              sx={currencyInputSx}
            />
            <CurrencyInput
              source={`salaryRanges.${index}.maxValue`}
              label="Max value"
              allowDecimal={false}
              endAdornment={salaryRangeAdornment('up')}
              formatInitialValue={formatCurrencyValue}
              maxDecimal={0}
              sx={currencyInputSx}
            />
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Box sx={{ width: 40, display: 'flex', justifyContent: 'center' }}>
                <CountryBadge country={range.country} sx={countryBadgeSx} />
              </Box>
              <Typography>{range.currency}</Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
    ),
  },
];
